import React, { useState, useEffect, useRef } from 'react'
import { Helmet } from "react-helmet-async";
import intlTelInput from "intl-tel-input";
import "intl-tel-input/build/css/intlTelInput.css";
import "intl-tel-input/build/js/utils";
function Booking() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    phone: ''
  })
  const phoneInputRef = useRef(null);
  const itiRef = useRef(null);
  useEffect(() => {
    if (!phoneInputRef.current) return;

    itiRef.current = intlTelInput(phoneInputRef.current, {
      initialCountry: "auto",
      nationalMode: false,        // Full international number
      separateDialCode: false,    // Avoid splitting dial code
      autoPlaceholder: "polite",
      geoIpLookup: (callback) => {
        fetch("https://ipapi.co/json")
          .then(res => res.json())
          .then(data => callback(data.country_code))
          .catch(() => callback("us"));
      }
    });

    return () => itiRef.current.destroy();
  }, []);






  const handleChange = (e) => {

    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = async (e) => {

    e.preventDefault()
    const iti = itiRef.current;


    const phone = itiRef.current.getNumber(); // E.164 or empty

    if (!phone || phone.length < 8) {
      alert("Please enter a phone number");
      return;
    }
    const payload = { ...formData, phone };

    try {
      const response = await fetch(process.env.REACT_APP_API_URL_EMAIL + '/send-enquiry', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
      const result = await response.json();
      if (response.ok) {

        alert(result.message || 'Message sent successfully!');
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: '',

        })
        if (iti) {
          iti.setNumber(""); // <- this resets the input
        }
      } else {
        alert('Failed to send message. Please try again.')
      }
    } catch (error) {
      console.error(error)
      alert('An error occurred. Please try again later.')
    }
  }

  return (
    <>    <Helmet>
      <title>Contact Us | Primedale Tours & Travel</title>

      <meta
        name="description"
        content="Contact Primedale Tours & Travel for safari bookings, tour packages, travel inquiries, and custom travel planning across Kenya and Africa."
      />

      <meta
        name="keywords"
        content="contact Primedale Tours, Kenya travel agency contact, safari bookings Kenya, tour inquiries, travel agency Nairobi"
      />

      <link
        rel="canonical"
        href="https://primedaletours.com/booking"
      />

      {/* Open Graph */}
      <meta property="og:title" content="Book With Us | Primedale Tours & Travel" />
      <meta
        property="og:description"
        content="Get in touch with Primedale Tours & Travel for safari tours, travel packages, and expert travel assistance in Kenya and Africa."
      />
      <meta property="og:url" content="https://primedaletours.com/booking" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Primedale Tours & Travel" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Book With Us | Primedale Tours & Travel" />
      <meta
        name="twitter:description"
        content="Reach out to Primedale Tours & Travel for safari bookings, tour planning, and travel support."
      />
    </Helmet>
      <div>
        <div className="container-fluid bg-primary py-5 mb-5 hero-header">
          <div className="container py-5">
            <div className="row justify-content-center py-5">
              <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
                <h1 className="display-3 text-white animated slideInDown">
                  Enquiry
                </h1>

              </div>
            </div>
          </div>
        </div>
        <div className="container-xxl py-5">
          <div className="container">
            <div className="booking p-5">
              <div className="row g-5 align-items-center">
                <div className="col-md-6 text-white">
                  <h1 className="text-white mb-4">Online Booking</h1>
                  <p>Book your tour easily using our secure form.</p>
                </div>

                <div className="col-md-6">
                  <h1 className="text-white mb-4">Book A Tour</h1>
                  <form onSubmit={handleSubmit} method="POST">
                    <div className="row g-3">
                      <div className="col-md-6">
                        <div className="form-floating">
                          <input
                            type="text"
                            name='name'
                            className="form-control"
                            id="name"
                            placeholder="Your Name"
                            value={formData.name}
                            onChange={handleChange}
                          />
                          <label htmlFor="name">Your Name</label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-floating">
                          <input
                            type="email"
                            className="form-control"
                            id="email"
                            name="email"
                            placeholder="Your Email"
                            value={formData.email}
                            onChange={handleChange}
                          />
                          <label htmlFor="email">Your Email</label>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group intl-input-wrapper">
                          <input
                            type="tel"
                            id='phone'
                            name='phone'
                            ref={phoneInputRef}
                            className="form-control"
                            placeholder="Your Phone"
                          />

                        </div>
                      </div>

                      <div className="col-12">
                        <div className="form-floating">
                          <input
                            type="text"
                            className="form-control"
                            id="subject"
                            name="subject"
                            placeholder="Subject"
                            value={formData.subject}
                            onChange={handleChange}
                          />
                          <label htmlFor="subject">Subject</label>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-floating">
                          <textarea
                            className="form-control"
                            placeholder="Leave a message here"
                            id="message"
                            style={{ height: 100 }}
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                          // defaultValue={""}
                          />
                          <label htmlFor="message">Message</label>
                        </div>
                      </div>
                      <div className="col-12">
                        <button className="navyblue-bg  w-100 py-3" type="submit">
                          Send Message
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </>
  )
}

export default Booking
